import { useMutation } from "@tanstack/react-query";
import { privateApi } from "../../../api/api";
import { ValidationErrorResponse } from "../../common/response/ValidationErrorResponse";
import { CreateInventoryCategoryFormData } from "../schema/CreateInventoryCategorySchema";
import { InventoryCategoryResponseSchema } from "../response/CreateInventoryCategoryResponse";

export const useCreateInventoryCategory = () => {
    return useMutation({
        mutationFn: async (formData: CreateInventoryCategoryFormData) => await privateApi.post(`/v4/inventory-category`, formData),
        onSuccess: async (response) => {
            try {
                const validationResult = InventoryCategoryResponseSchema.safeParse(response.data);

                if (!validationResult.success) {
                    console.error("Validation failed:", validationResult.error.errors);
                    throw new Error("Invalid inventory category data format");
                }

                return validationResult.data
            } catch (error) {
                console.error('Failed to create inventory category', error);
                throw error;
            }
        },
        onError: (error) => {
            const validationResult = ValidationErrorResponse.safeParse((error as any).response.data);

            if (!validationResult.success) {
                console.error("Validation failed:", validationResult.error.errors);
                throw new Error("Invalid inventory category data format");
            } else {
                console.error(`Failed to create inventory category`, error);
                throw error;
            }
        }
    });
};
